// extracted by mini-css-extract-plugin
export default {"box":"pdf-icon_box__vwa8c","preview":"pdf-icon_preview__gHEC0","download":"pdf-icon_download__g1pvS","downloadIcon":"pdf-icon_downloadIcon__P7xb6"};